import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import API from "../../services/API";
import { TokenService } from "../../services/LocalStorage";
import { RootState } from "../store";

interface ISelect {
  value: string;
  label: string;
}

interface CIState {
  list: ISelect[];
}

const initialState: CIState = {
  list: [],
};

export const CIStore = createSlice({
  name: "request",
  initialState,
  reducers: {
    setCIs: (state: { list: ISelect[] }, action: PayloadAction<ISelect[]>) => {
      state.list = action.payload;
    },
    cleanStore: () => {
      return { ...initialState };
    },
  },
});

export const getCIs = (username: string) => async (dispatch: any) => {
  try {
    API()
      .get(
        `assets/GetAssetsByUser?token=${TokenService.get()}&onbehalftoid=${username}`
      )
      .then((response) => {
        const data: ISelect[] = [];
        response.data.Values.forEach((CIItem: any) => {
          data.push({
            value: CIItem.CIID,
            label: CIItem.CIName,
          });
        });
        dispatch(setCIs(data));
      });
  } catch (e: any) {
    return console.error(e.message);
  }
};

export const { setCIs, cleanStore } = CIStore.actions;
export const ci = (state: RootState) => state.ci;
export default CIStore.reducer;
